import type { ReactNode } from 'react'
import ScrollItem from './ScrollItem'

const ScrollView = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <div className={`flex items-center overflow-x-auto whitespace-nowrap ${className ?? ''}`}>{children}</div>
}

ScrollView.Item = ScrollItem

export default ScrollView
